/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx';
import { useState, useEffect, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { KTSVG, toAbsoluteUrl } from '../../../helpers';
import { useLayout } from '../../core';
import { isFluidLayoutPath, toFluidContainerClass } from '../../core/fluidLayoutPaths';
import { DefaultTitle } from './page-title/DefaultTitle';
import { Topbar } from './Topbar';
const calculateStickyOffset = (header) => {
    if (header.fixed.desktop && header.fixed.tabletAndMobile) {
        return '{default: "200px", lg: "300px"}';
    }
    if (header.fixed.desktop && !header.fixed.tabletAndMobile) {
        return '{lg: "300px"}';
    }
    if (header.fixed.tabletAndMobile && !header.fixed.desktop) {
        return '{default: "200px", lg: false}';
    }
    return '';
};
const calculateShowSticky = (header) => {
    return ((header.fixed.desktop && header.fixed.tabletAndMobile) ||
        (header.fixed.desktop && !header.fixed.tabletAndMobile) ||
        (header.fixed.tabletAndMobile && !header.fixed.desktop));
};
export function HeaderWrapper() {
    const { config, classes, attributes } = useLayout();
    const { header } = config;
    const location = useLocation();
    const [stickyOffset, setStickyOffset] = useState(calculateStickyOffset(header));
    const [showSticky, setShowSticky] = useState(calculateShowSticky(header));
    useEffect(() => {
        setStickyOffset(calculateStickyOffset(header));
        setShowSticky(calculateShowSticky(header));
    }, [header]);

    const headerContainerClassName = useMemo(
        () => toFluidContainerClass(classes.headerContainer, isFluidLayoutPath(location.pathname)),
        [classes.headerContainer, location.pathname]
    );

    return (<div id='kt_header' className={clsx('header', classes.header.join(' '))} {...attributes.headerMenu} data-kt-sticky={showSticky ? 'true' : 'false'} data-kt-sticky-name='header' data-kt-sticky-offset={stickyOffset}>
      <div className={clsx(headerContainerClassName, 'd-flex flex-stack flex-wrap gap-2')} id='kt_header_container'>
        <DefaultTitle />

        {/* begin::Wrapper */}
        <div className='d-flex d-lg-none align-items-center ms-n2 me-2'>
          {/* begin::Aside mobile toggle */}
          <div className='btn btn-icon btn-active-icon-primary' id='kt_aside_toggle'>
            <KTSVG path='/media/icons/duotune/abstract/abs015.svg' className='svg-icon-1 mt-1'/>
          </div>
          {/* end::Aside mobile toggle */}

          {/* begin::Logo */}

          <Link to='/dashboard' className='d-flex align-items-center'>
            <img alt='Logo' width="300" src={toAbsoluteUrl('/media/logos/vtsl_logo_black.png')} className='h-20px'/>
          </Link>
          {/* end::Logo */}
        </div>
        {/* end::Wrapper */}
        <Topbar />
      </div>
    </div>);
}
